import { SET_PAGE_SETTINGS } from "../../constants/actionTypes"
import {reloadAppSettings} from "../../store/actions";

const setPageSettings = (settings) => (dispatch) => {
    dispatch ({
      type: SET_PAGE_SETTINGS,
      payload: settings
    });
    dispatch(reloadAppSettings(settings));
};

export {
    setPageSettings,
}